/* eslint-disable @typescript-eslint/no-unused-vars */
import { createModel } from '@wmfe/mach-pro-store';
import { showIndicator } from '@/src/pages/address/selector_page/utils/loading';
import { REFRESH_TYPE } from '../utils/constant';

export const filterBarHandleModel = createModel()({
  state: {
    filterBarPanelHandleParentViewRef: null,
    filterBarHandleLxModel: {},
    filterBarHandlePopupWillShowIntercept: undefined,
    filterBarHandlePanelItemDidSelectedIntercept: undefined,
    filterBarHandlePanelDataPayload: {},
  },

  reducers: {
  },

  effects: (dispatch) => ({

    didFilterBarDataSelectedChanged: (payload) => {
      const { options } = payload;
      // 刷新feed区数据
      dispatch.global.handleShowLoading(true);
      const { filterOptionRefreshTag } = options;
      dispatch.global.fetchFeedListData({
        pageNo: 0,
        options,
        // 自取场景点击筛排需要刷新筛排数据
        refreshType: filterOptionRefreshTag ? REFRESH_TYPE.CLICK_FILTERBAR_REFRESH_TAG : REFRESH_TYPE.CLICK_FILTERBAR,
        showIndicator: false
      });
    },

    didFilterBarPanelExpandedChanged: (payload) => {
      //dispatch.global.updateFilterBarPanelInMainExpanded(payload)
    },

    updateFilterBarHandlePanelParentViewRef: (payload, { filterBarHandleModel }) => {
      const { ref } = payload;
      // @ts-ignore
      filterBarHandleModel.filterBarPanelHandleParentViewRef = ref;
      dispatch.filterBarModel?.updateFilterBarPanelParentViewRef?.(payload);
    },

    updateFilterBarHandleLxSourceModel: (payload, { filterBarHandleModel }) => {
      const { lxModel } = payload;
      // @ts-ignore
      filterBarHandleModel.filterBarHandleLxModel = lxModel;
      dispatch.filterBarModel?.updateFilterBarLxSourceModel?.(payload);
    },

    updateFilterBarHandlePanelData: (payload, { filterBarHandleModel }) => {
      // @ts-ignore
      filterBarHandleModel.filterBarHandlePanelDataPayload = payload;
      dispatch.filterBarModel?.updateFilterBarPanelData?.(payload);
    },

    updateBindFilterIntercepts: (payload, { filterBarHandleModel }) => {
      const { popupWillShowIntercept, panelItemDidSelectedIntercept } = payload;
      // @ts-ignore
      filterBarHandleModel.filterBarHandlePopupWillShowIntercept = popupWillShowIntercept;
      // @ts-ignore
      filterBarHandleModel.filterBarHandlePanelItemDidSelectedIntercept = panelItemDidSelectedIntercept;

      dispatch.filterBarModel?.bindFilterBarPopupWillShowIntercept?.({ intercept: popupWillShowIntercept });
      dispatch.filterBarModel?.bindFilterBarPanelItemDidSelectedIntercept?.({ intercept: panelItemDidSelectedIntercept });
    },

  })
});
